import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w-lg-900px bg-white rounded shadow-sm p-10 mx-auto row" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-6\"><div class=\"mb-6\"><img alt=\"Logo\" src=\"media/logos/logo-1.svg\" class=\"h-50px\"></div><h2 class=\"text-dark mt-3\"> Skills for Employment Investment Program (SEIP) </h2><div><p class=\"mb-0\">Probashi Kalyan Bhaban (Level-16)</p><p>71-72 Old Elephant Road, Eskaton Garden, Dhaka-1000.</p><div style=\"margin-top:33%;\"></div></div></div>", 1)
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = { class: "form w-100" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-10" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3" }, "User Switcher")
], -1)
const _hoisted_6 = { class: "row m-0" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "row" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "text-primary fw-bold fs-3 mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (entity, index) => {
            return (_openBlock(), _createElementBlock("button", {
              key: index,
              class: "col-md-5 card d-flex align-items-center px-6 py-8 rounded-2 m-3",
              onClick: ($event: any) => (_ctx.userSwitcher(entity?.entity_info?.id))
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("img", {
                  src: _ctx.api_url + entity?.entity_info?.attach_file_info?.thumb_dir,
                  alt: "Logo",
                  class: "h-75px"
                }, null, 8, _hoisted_9),
                _createElementVNode("span", _hoisted_10, _toDisplayString(entity?.entity_info?.entity_short_name), 1)
              ])
            ], 8, _hoisted_7))
          }), 128))
        ])
      ])
    ])
  ]))
}